import React from 'react';
import { Panel } from '@michelin/acid-components';
import { VehicleType } from 'types/UFOTypes';
import { VehicleInformation } from './VehicleInformation';

interface VehicleOptionProps {
  data?: VehicleType;
}

export function VehicleOption({ data }: VehicleOptionProps) {
  if (!data) return null;
  return (
    <Panel dense variant="secondary">
      <VehicleInformation vehicle={data} />
    </Panel>
  );
}
